let savedScrollY = 0;
let locked = false;

export function lockScroll() {
    if (locked) return;
    locked = true;
    savedScrollY = window.scrollY;

    const body = document.body;
    body.style.position = "fixed";
    body.style.top = `-${savedScrollY}px`;
    body.style.width = "100%";
    body.style.overflow = "hidden";
}

export function unlockScroll() {
    if (!locked) return;
    locked = false;

    const body = document.body;
    body.style.removeProperty("position");
    body.style.removeProperty("top");
    body.style.removeProperty("width");
    body.style.removeProperty("overflow");

    window.scrollTo(0, savedScrollY);
}